import Svg, { Circle, Path } from 'react-native-svg'
/* SVGR has dropped some elements not supported by react-native-svg: filter */
const SuccessIconTick = ({ width = 24, height = 24, color = '#25AB21' }: any) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
    <Circle cx={12} cy={12} r={10} fill="#fff" />
    <Path
      fill={color}
      d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm5.21 7.71-6 6a1.002 1.002 0 0 1-1.42 0l-3-3a1.003 1.003 0 1 1 1.42-1.42l2.29 2.3 5.29-5.3a1.004 1.004 0 0 1 1.42 1.42Z"
    />
  </Svg>
)
export const SuccessIconTickSmall = ({ width = 16, height = 16, color = '#00B259' }: any) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
    <Path
      fill={color}
      d="M8 1.333a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 8 1.333Zm3.473 5.14-4 4a.666.666 0 0 1-.946 0l-2-2a.67.67 0 1 1 .946-.946L7 9.06l3.527-3.533a.67.67 0 1 1 .946.946Z"
    />
  </Svg>
)

export default SuccessIconTick
